import { Button } from "components/Button/Button";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { dataIsAvailable, dateFormat } from "utils";
import { Input, TextArea } from "components/Form";
import {
    addFreeCourseAccess,
    getDeviceLogListViaStudentEmail,
    getdetailsofstudentViaStudentEmailorphone,
} from "services/student/studentController";
// import CourseModal from "./Sections/CourseModal";
import ModalBox from "components/modal/ModalBox";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import CommentBankIcon from "@mui/icons-material/CommentBank";
import Paper from "@mui/material/Paper";
// import CommentRow from "./CommentRow";
import { useSearchParams } from "react-router-dom";
// import BulkCourseModal from "./Sections/BulkCourseModal";
import { getSignedUrl } from "services/master";
import { getExpMobileAccessReport } from "services/reports/reportController";
import * as XLSX from "xlsx";
import { lime } from "@mui/material/colors";

const ExpMobileAccessReport = () => {
    const [searchParam, setSearchParam] = useSearchParams();
    const [activePage, setActivePage] = useState(1);
    let search = searchParam.get("query") || "";

    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [submitButtonElement2, setSubmitLoading2] = useMuiButtonLoader();
    const [userEmail, setUserEmail] = useState(search || "");
    const [selectedCourseId, setSelectedCourseId] = useState("");
    const [userData, setUserData] = useState({});

    const [courseModal, setCourseModal] = useState(false);
    const [bulkAssignModal, setBulkAssignModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [revokeModal, setRevokeModal] = useState(false);
    const [commentModal, setCommentModal] = useState(false);
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState("");
    const [allComments, setAllComments] = useState([]);
    const [studentDetails, setExpMobileAccessReport] = useState(null);
    const [appliedSearch, setAppliedSearch] = useState("");


    const [record, setRecord] = useState([]);
    const [total, setTotal] = useState(0);
    const [loader, showLoader, hideLoader] = useFullPageLoader();



    const searchHandler = async (e) => {
        e.preventDefault();

        if (!userEmail) {
            toast.error("Please enter email or phone");
            return;
        }

        setActivePage(1);              // RESET TO PAGE 1
        setAppliedSearch(userEmail);   // STORE SEARCH
    };

    React.useEffect(() => {
        fetchDeviceLogs(appliedSearch);
        // eslint-disable-next-line
    }, [activePage, appliedSearch]);




    const fetchDeviceLogs = async (searchValue = "") => {
        try {
            showLoader();
            const finalData = {
                page: activePage,
                ...(searchValue ? { search: searchValue } : {})
            };

            const res = await getExpMobileAccessReport(finalData);
            hideLoader();

            if (res.code === 200) {
                setRecord(res.data.expmobileLogreport.rows || []);
                setTotal(res.data.expmobileLogreport.count || 0);
            } else {
                toast.error(res.message);
                setRecord([]);
            }
        } catch (err) {
            hideLoader();
            toast.error(err?.response?.data?.message || err.message);
        }
    };




    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        searchParam.set("page", event);
        setSearchParam(searchParam);
    };


    const resetFilter = () => {
        setUserEmail("");        // Clear input
        setAppliedSearch("");    // Clear applied search
        setActivePage(1);        // Reset page
    };

    const downloadExcelHandler = async (searchValue = "") => {
        if (searchValue && typeof searchValue !== "string") {
            searchValue = "";
        }

        setSubmitLoading2(true);
        showLoader();

        const finalData = {
            page: 1,
            limit: 10000000,
            type: "excel",
            ...(searchValue ? { search: searchValue } : {})
        };

        const res = await getExpMobileAccessReport(finalData);
        hideLoader();
        setSubmitLoading2(false);

        if (res.code === 200) {
            const data = res.data.expmobileLogreport.rows.map((row, i) => ({
                "S.NO": i + 1,
                "Student Name": `${row?.userdata?.FirstName || ""} ${row?.userdata?.LastName || ""}`,
                "Email": row?.userdata?.EmailID || "",
                "Mobile": row?.userdata?.Mobile || "",
                "Course": row?.coursedata?.CourseTitle || "",
                "Access Date": dateFormat(row?.addedon) || "",
            }));


            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, ws, "DeviceLogs");
            XLSX.writeFile(wb, "Mobile Course Access.xlsx");
        } else {
            toast.error(res.message);
        }
    };




    return (
        <React.Fragment>
            <title>Shubhra Viraj | Mobile Course Access Report</title>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="SearchBox"></div>
                            <h4 className="Title">Mobile Course Access Report</h4>
                        </div>
                        <div className=" mt-3">
                            <form onSubmit={searchHandler}>
                                <div className="row w-100">
                                    <div className={`col-form-label py-0 col-sm-7`}>
                                        <Input
                                            className={"form-control"}
                                            placeholder="Enter User Email Address or Phone"
                                            value={userEmail}
                                            onChange={({ target }) => setUserEmail(target.value)}
                                            type="text"
                                        />
                                    </div>

                                    <div className="col-sm-5 d-flex justify-content-left gap-3">
                                        <Button type="submit" {...submitButtonElement}>
                                            Search
                                        </Button>
                                        <Button
                                            className="refresh_btnn"
                                            onClick={resetFilter}
                                            style={{
                                                height: "42px",
                                                width: "42px",
                                            }}
                                        >
                                            <i className="fa fa-refresh"></i>
                                        </Button>
                                        <Button
                                            onClick={() => downloadExcelHandler(appliedSearch)}
                                            {...submitButtonElement2}
                                        >
                                            Export to Excel
                                        </Button>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="Small-Wrapper" style={{ marginTop: "10px" }}>
                        {record && record.length > 0 ? (
                            <div className="row mt-3" >
                                <div className="col-sm-12">
                                    <div className="TableList overflow-auto table-responsive" style={{ paddingTop: "0px" }}>
                                        <h4 style={{ marginBottom: "10px" }}>Mobile Course Access (Total Records {" "} {`${total}`})</h4>
                                        {/* <table className="position-relative"> */}
                                        <table className="table table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Student Name</th>
                                                    <th>Email</th>
                                                    <th>Mobile</th>
                                                    <th>Course</th>
                                                    <th>Access Date</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {record.length > 0 ? (
                                                    record.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{(activePage - 1) * 10 + index + 1}</td>
                                                            <td>{item?.userdata?.FirstName} {item?.userdata?.LastName}</td>
                                                            <td>{item?.userdata?.EmailID}</td>
                                                            <td>{item?.userdata?.Mobile}</td>
                                                            <td
                                                                style={{
                                                                    maxWidth: "450px",        // adjust width as needed
                                                                    whiteSpace: "normal",     // allow wrapping
                                                                    wordBreak: "break-word",  // break long words
                                                                    overflowWrap: "anywhere" // modern safe wrap
                                                                }}
                                                            >{item?.coursedata?.CourseTitle}</td>
                                                            <td style={{ textAlign: "left" }}>{dateFormat(item?.addedon)}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">
                                                            No record found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                    </div>
                                    {total > 10 ? (
                                        <div className="Pagination my-2">
                                            <Pagination
                                                activePage={activePage}
                                                itemsCountPerPage={10}
                                                totalItemsCount={total}
                                                pageRangeDisplayed={5}
                                                onChange={(page) => setActivePage(page)}
                                            />

                                        </div>
                                    ) : null}

                                </div>
                            </div>
                        ) : (
                            <NotFound cols={5} />
                        )}


                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ExpMobileAccessReport;
